import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { ErrorData, errorResult } from '@synergy/api';
import { FormikErrors } from 'formik';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { FormValues } from '../models/form-values';
import { ProductAttributesList } from '../models/product-attributes-list';
import { productDetailAttributesRequestSelector } from './product-detail-attributes-selectors';

export const PRODUCT_DETAIL_ATTRIBUTE_FETCH = 'PRODUCT_DETAIL_ATTRIBUTE_FETCH';
export const PRODUCT_DETAIL_ATTRIBUTE_UPDATE = 'PRODUCT_DETAIL_ATTRIBUTE_UPDATE';
export const PRODUCT_DETAIL_ATTRIBUTE_SAVE = 'PRODUCT_DETAIL_ATTRIBUTE_SAVE';
export const PRODUCT_DETAIL_ATTRIBUTE_RECEIVE = 'PRODUCT_DETAIL_ATTRIBUTE_RECEIVE';
export const PRODUCT_DETAIL_ATTRIBUTE_ERROR = 'PRODUCT_DETAIL_ATTRIBUTE_ERROR';

const error = (errorData?: ErrorData) => ({
    type: PRODUCT_DETAIL_ATTRIBUTE_ERROR,
    errorData,
});

const receiveAttributes = (attributesList: ProductAttributesList) => ({
    type: PRODUCT_DETAIL_ATTRIBUTE_RECEIVE,
    attributesList,
});

export const updateAttributes = (
    formData: FormValues,
    isDirty: boolean,
    isValid: boolean,
    errors: FormikErrors<FormValues>
) => {
    return {
        type: PRODUCT_DETAIL_ATTRIBUTE_UPDATE,
        formData,
        isDirty,
        isValid,
        errors,
    };
};

export const saveAttributes = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DETAIL_ATTRIBUTE_SAVE });
        const requestData = productDetailAttributesRequestSelector(getState());
        if (!requestData) {
            return errorResult();
        }

        const response = await api.product.detail.attributes.patchAttributes(requestData.id, requestData.attributes);
        if (response.success) {
            dispatch(receiveAttributes(response.result));
        } else {
            dispatch(error(response.error));
        }
        return response;
    };
};

export const fetchAttributes = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_DETAIL_ATTRIBUTE_FETCH });

        const response = await api.product.detail.attributes.getAttributes(id);
        if (response.success) {
            dispatch(receiveAttributes(response.result));
        } else {
            dispatch(error(response.error));
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
